import { render, staticRenderFns } from "./OrderServices.vue?vue&type=template&id=03614d2f&scoped=true"
import script from "./OrderServices.vue?vue&type=script&lang=js"
export * from "./OrderServices.vue?vue&type=script&lang=js"
import style0 from "./OrderServices.vue?vue&type=style&index=0&id=03614d2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03614d2f",
  null
  
)

export default component.exports